import { SimpleCustomerDto } from 'enrollment-platform/api/persons/dto/simple-customer.dto'
import { CensusClientFilter } from '../../types/census-client-filter'
import {
  ROLE_PLATFORM_HIXME_ADMIN,
  ROLE_BROKER,
  ROLE_CLIENT_ADMIN,
} from '@hixme/role-policy'

/**
 * Filters clients based on test company preference
 * @param clients - Array of clients to filter
 * @param includeTestCompanies - Whether to include test companies in the result
 * @returns Filtered array of clients
 */
export const filterClients = (
  clients: SimpleCustomerDto[],
  filter?: CensusClientFilter,
  role?: string
): SimpleCustomerDto[] => {
  const isAdmin = [
    ROLE_PLATFORM_HIXME_ADMIN,
    ROLE_BROKER,
    ROLE_CLIENT_ADMIN,
  ].includes(role)

  // If a client is selected, return that client
  if (filter?.selectedClient) {
    return [filter.selectedClient]
    // If admin, return empty array so that they can see all clients
  } else if (isAdmin) {
    return []
  }

  return clients
}
